// 설치안내(설명 페이지) 전용 플랫 라인 SVG 아이콘 세트 (2026-09-08 사용자).
//   스타일 = evs.com/applications 참고 '플랫 라인 아이콘'(네이비 스트로크 + 시안 단일 액센트).
//   ★내용 부합: 우리 대기환경/방지시설/측정 도메인에 맞는 아이콘만. viewBox 48. stroke=2.2.
//   사용: GUIDE_ICON[name]. 없는 키는 null → 렌더 측에서 가드.
const NAVY = '#1c2330';
const CYAN = '#00AEEF';

// 공통 svg 래퍼 속성
const P = { viewBox: '0 0 48 48', fill: 'none', stroke: NAVY, strokeWidth: 2.2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

export const GUIDE_ICON: Record<string, JSX.Element> = {
  // 제조사/게이트웨이 — 회로+칩
  gateway: (
    <svg {...P}><rect x="12" y="12" width="24" height="24" rx="3" /><rect x="20" y="20" width="8" height="8" fill={CYAN} stroke="none" /><path d="M12 18H7M12 24H7M12 30H7M36 18h5M36 24h5M36 30h5M18 12V7M24 12V7M30 12V7M18 36v5M24 36v5M30 36v5" /></svg>
  ),
  // 대기오염 관리 — 구름
  air: (
    <svg {...P}><path d="M16 32h16a7 7 0 0 0 .6-14A10 10 0 0 0 13 20a6 6 0 0 0 3 12Z" /><path stroke={CYAN} d="M20 38h8M17 42h6" /></svg>
  ),
  // 스마트 에너지 — 번개
  energy: (
    <svg {...P}><path d="M26 6 12 28h9l-1 14 16-24h-9l3-12Z" /><circle cx="24" cy="24" r="20" stroke={CYAN} strokeWidth="0" /></svg>
  ),
  // 환경 모니터링 — 순환 지구
  monitor: (
    <svg {...P}><circle cx="24" cy="24" r="12" /><path d="M12 24h24M24 12c4 3 4 21 0 24M24 12c-4 3-4 21 0 24" /><path stroke={CYAN} d="M38 14a18 18 0 0 1 2 10M10 34a18 18 0 0 1-2-10" /></svg>
  ),
  // 실시간 수집·분석 — 순환 화살표
  cycle: (
    <svg {...P}><path d="M40 24a16 16 0 1 1-4.7-11.3" /><path stroke={CYAN} d="M36 6v8h-8" /></svg>
  ),
  // 인증 — 방패+체크
  certified: (
    <svg {...P}><path d="M24 5 40 11v10c0 10-7 18-16 22-9-4-16-12-16-22V11Z" /><path stroke={CYAN} d="m17 24 5 5 10-11" /></svg>
  ),
  // 전송률 — 신호 안테나
  signal: (
    <svg {...P}><path d="M24 40V22" /><circle cx="24" cy="18" r="4" fill={CYAN} stroke="none" /><path d="M14 28a14 14 0 0 1 20 0M18 32a8 8 0 0 1 12 0" /></svg>
  ),
  // 맞춤 솔루션 — 톱니
  solution: (
    <svg {...P}><circle cx="24" cy="24" r="6" /><path d="M24 6v6M24 36v6M6 24h6M36 24h6M11 11l4 4M33 33l4 4M37 11l-4 4M15 33l-4 4" /><circle cx="24" cy="24" r="2" fill={CYAN} stroke="none" /></svg>
  ),
  // 개발/코드 — 앵글 브래킷 </> + 시안 슬래시 (viewBox 24 Lucide code-2, 스트로크 48세트와 시각 맞춤)
  code: (
    <svg {...P} viewBox="0 0 24 24" strokeWidth={1.5}><path d="m18 16 4-4-4-4M6 8l-4 4 4 4" /><path stroke={CYAN} d="m14.5 4-5 16" /></svg>
  ),
  // 조립 — 렌치(공구) (viewBox 24 Lucide wrench + 시안 포인트)
  wrench: (
    <svg {...P} viewBox="0 0 24 24" strokeWidth={1.5}><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" /><circle cx="17.3" cy="6.7" r=".9" fill={CYAN} stroke="none" /></svg>
  ),
  // 원심력집진 — 사이클론 소용돌이
  cyclone: (
    <svg {...P}><path d="M38 12H14M36 20H16M32 28H20M28 34h-6" /><path stroke={CYAN} d="M24 34c-2 3-2 6 0 8" /></svg>
  ),
  // 여과집진 — 필터
  filter: (
    <svg {...P}><path d="M8 10h32l-12 14v14l-8-4V24Z" /><path stroke={CYAN} d="M18 15h12" /></svg>
  ),
  // 흡착 — 벌집/다공
  adsorb: (
    <svg {...P}><path d="m18 8 6 4v8l-6 4-6-4v-8ZM30 8l6 4v8l-6 4-6-4M18 28l6 4v8l-6 4-6-4v-8Z" /><circle cx="30" cy="32" r="4" fill={CYAN} stroke="none" /></svg>
  ),
  // 전기집진 — 전극+전하
  electro: (
    <svg {...P}><path d="M14 8v32M34 8v32" /><path stroke={CYAN} d="M20 18l8 4-8 4 8 4" /></svg>
  ),
  // 세정집진 — 물분사
  scrub: (
    <svg {...P}><path d="M16 8h16v6a8 8 0 0 1-16 0Z" /><path stroke={CYAN} d="M20 26v6M24 26v10M28 26v6M22 40v3M26 40v3" /></svg>
  ),
  // 흡수(pH) — 액체 방울
  droplet: (
    <svg {...P}><path d="M24 6c8 10 12 15 12 22a12 12 0 0 1-24 0c0-7 4-12 12-22Z" /><path stroke={CYAN} d="M18 30a6 6 0 0 0 6 6" /></svg>
  ),
  // 배출시설/공장 — 굴뚝 연기
  factory: (
    <svg {...P}><path d="M8 40V22l10 6V22l10 6V16h12v24Z" /><path stroke={CYAN} d="M34 12c0-3 3-3 3-6M40 12c0-3 3-3 3-6" /></svg>
  ),
  // 계측기 — 게이지
  gauge: (
    <svg {...P}><path d="M8 34a16 16 0 0 1 32 0" /><path d="M24 34 33 20" stroke={CYAN} /><circle cx="24" cy="34" r="2.5" fill={NAVY} stroke="none" /></svg>
  ),
  // 법/의무 — 문서 체크
  doc: (
    <svg {...P}><path d="M14 6h14l8 8v28H14Z" /><path d="M28 6v8h8" /><path stroke={CYAN} d="m19 28 3 3 6-7" /></svg>
  ),
  // 기한 — 캘린더
  calendar: (
    <svg {...P}><rect x="9" y="12" width="30" height="28" rx="3" /><path d="M9 20h30M17 8v8M31 8v8" /><rect x="20" y="27" width="8" height="7" fill={CYAN} stroke="none" /></svg>
  ),
  // 지원금 — 원화 코인
  won: (
    <svg {...P}><circle cx="24" cy="24" r="17" /><path stroke={CYAN} d="M16 19h16M16 24h16" /><path d="M17 19l4 11 3-8 3 8 4-11" /></svg>
  ),
  // 채널 ON/OFF — 토글 스위치
  toggle: (
    <svg {...P}><rect x="6" y="15" width="36" height="18" rx="9" /><circle cx="33" cy="24" r="6" fill={CYAN} stroke="none" /></svg>
  ),
  // AI 분석 — 스파클
  ai: (
    <svg {...P}><path d="M19 7l2.6 7.4L29 17l-7.4 2.6L19 27l-2.6-7.4L9 17l7.4-2.6Z" /><path fill={CYAN} stroke="none" d="M33 27l1.4 4 4 1.4-4 1.4L33 38l-1.4-4-4-1.4 4-1.4Z" /></svg>
  ),
  // 다채널 알림 — 벨
  bell: (
    <svg {...P}><path d="M24 6a9 9 0 0 0-9 9c0 8-3 10-3 10h24s-3-2-3-10a9 9 0 0 0-9-9Z" /><path stroke={CYAN} d="M20.5 40a3.5 3.5 0 0 0 7 0" /></svg>
  ),
  // 모바일 앱 — 스마트폰
  phone: (
    <svg {...P}><rect x="15" y="5" width="18" height="38" rx="4" /><path d="M15 12h18M15 37h18" /><rect x="21" y="8" width="6" height="1.8" rx=".9" fill={CYAN} stroke="none" /><circle cx="24" cy="40" r="1.4" fill={CYAN} stroke="none" /></svg>
  ),
  // 조치 입력 — 체크리스트+펜
  action: (
    <svg {...P}><path d="M10 8h20l6 6v26H10Z" /><path d="M30 8v6h6" /><path stroke={CYAN} d="M16 22h10M16 28h6" /><path stroke={CYAN} d="m28 30 3 3 6-7" /></svg>
  ),
  // 경고/위반 — 삼각 경고
  alert: (
    <svg {...P}><path d="M24 7 42 39H6Z" /><path stroke={CYAN} d="M24 20v8" /><circle cx="24" cy="33" r="1.6" fill={CYAN} stroke="none" /></svg>
  ),
  // 데이터 장기 보관 — 실린더 스택(DB)
  database: (
    <svg {...P}><ellipse cx="24" cy="12" rx="14" ry="5" /><path d="M10 12v24c0 2.8 6.3 5 14 5s14-2.2 14-5V12" /><path d="M10 24c0 2.6 6.3 5 14 5s14-2.4 14-5" /><path stroke={CYAN} d="M10 31c0 2.6 6.3 5 14 5s14-2.4 14-5" /></svg>
  ),
  // 사업장/건물
  building: (
    <svg {...P}><path d="M12 42V10h16v32M28 42V20h8v22" /><path stroke={CYAN} d="M17 16h4M17 22h4M17 28h4M17 34h4" /></svg>
  ),

  // ── 알림 채널 아이콘(2026-10-12 사용자) — 다채널 알림 칩용. 세련·심플. 타 페이지 '채널 나열'에도 재사용. ──
  // SMS/문자 — 말풍선 + 텍스트 라인
  sms: (
    <svg {...P}><path d="M8 11h32a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2H21l-9 7v-7H8a2 2 0 0 1-2-2V13a2 2 0 0 1 2-2Z" /><path stroke={CYAN} d="M15 19h18M15 25h11" /></svg>
  ),
  // 카카오톡 — 채팅 말풍선 + 점 3개(대화)
  kakao: (
    <svg {...P}><path d="M24 8c9.4 0 17 5.8 17 13s-7.6 13-17 13c-1.6 0-3.1-.2-4.6-.5L11 38l2-6.6C9.3 28.9 7 24.7 7 21 7 13.8 14.6 8 24 8Z" /><circle cx="17" cy="21" r="1.7" fill={CYAN} stroke="none" /><circle cx="24" cy="21" r="1.7" fill={CYAN} stroke="none" /><circle cx="31" cy="21" r="1.7" fill={CYAN} stroke="none" /></svg>
  ),
  // 앱푸시 — 스마트폰 + 푸시 신호파
  apppush: (
    <svg {...P}><rect x="11" y="9" width="17" height="32" rx="4" /><path d="M11 35h17" /><circle cx="19.5" cy="38" r="1.3" fill={CYAN} stroke="none" /><path stroke={CYAN} d="M33 10a8 8 0 0 1 5 7M33 16a3.5 3.5 0 0 1 2 3" /></svg>
  ),
  // 이메일 — 봉투
  email: (
    <svg {...P}><rect x="6" y="11" width="36" height="26" rx="3" /><path stroke={CYAN} d="m7 14 17 13L41 14" /></svg>
  ),
  // 전광판 — 대형 디스플레이(스탠드) + 전광 텍스트 라인
  display: (
    <svg {...P}><rect x="5" y="8" width="38" height="23" rx="2" /><path d="M24 31v7M16 41h16" /><path stroke={CYAN} d="M11 15h12M11 21h20M11 27h8" /></svg>
  ),
};
